const carouselItems = [
  {
    seq: 'carousel-01',
    title: '2026暑期档：影视圈连环塌房全记录',
    desc: '从大制作电影票房翻车到知名导演被曝丑闻，这个暑期档的瓜比正片还精彩。我们为你梳理了最近两个月影视圈最劲爆的十大塌房事件。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20industry%20scandal%20themed%20visual%2C%20dramatic%20film%20set%20with%20breaking%20news%20aesthetic%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20entertainment%20news%20collage%20style%2C%20bold%20graphic%20design%2C%20eye-catching%20headline%20composition&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    seq: 'carousel-02',
    title: '头部网红大洗牌：谁在崛起谁在陨落',
    desc: '短视频平台流量红利见顶，曾经月入千万的头部网红们面临前所未有的危机。解约潮、塌房潮、转型潮三潮叠加，网红圈正在经历一场大洗牌。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Internet%20celebrity%20industry%20reshuffle%20visual%2C%20social%20media%20influencer%20theme%2C%20modern%20digital%20culture%20aesthetic%2C%20warm%20amber%20and%20coral%20tones%2C%20dramatic%20graphic%20design%2C%20trending%20topic%20composition&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    seq: 'carousel-03',
    title: '综艺节目幕后：你以为的"真实"其实是剧本',
    desc: '前综艺编剧匿名爆料，揭秘选秀节目、恋爱综艺、真人秀的剧本机制。从人设打造到冲突制造，你所看到的每一个"名场面"背后都有精心设计。',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20behind%20the%20scenes%20reveal%2C%20scripted%20reality%20TV%20theme%2C%20dramatic%20lighting%20studio%20set%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20visual&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    seq: 'carousel-04',
    title: '娱乐圈税务风暴再起：谁在瑟瑟发抖',
    desc: '继前几年大规模查税行动后，新一轮娱乐圈税务稽查已悄然启动。多位艺人工作室被约谈，补税金额或创历史新高。我们整理了一份最全时间线和涉事名单。',
    tag: '重磅追踪',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20tax%20investigation%20theme%2C%20financial%20scandal%20visual%2C%20dramatic%20corporate%20office%20atmosphere%2C%20warm%20coral%20and%20amber%20palette%2C%20breaking%20news%20graphic%20style%2C%20serious%20investigative%20journalism%20aesthetic&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-4">
            <i className="ri-focus-2-line"></i>
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            重磅专题报道
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            深度挖掘，多角度呈现，你不能错过的焦点吃瓜专题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`51吃瓜在线专题-${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`51吃瓜在线焦点专题-${item.title}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 bg-accent-500 text-background-50 text-xs px-3 py-1 rounded-full font-bold">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}